import { create } from 'zustand';
import type { Route } from '../context/types';
import { RoutePath } from '../pages';

type State = {
  route: Route;
};

type Actions = {
  setRoute: (value: Route | RoutePath) => void;
};

const initialState = { path: RoutePath.Signup };

export const useRouteState = create<State & Actions>((set) => ({
  route: initialState,
  setRoute: (value) => {
    if (typeof value === 'string') {
      set({
        route: {
          path: value,
        },
      });
    } else {
      set({ route: value });
    }
  },
}));
